import React from "react"
import a23logo from '../assets/a23_avatar_logo.png'
import { connect } from "react-redux";
import close from "../assets/close.png";
import { toggleModalAction } from '../redux/actions/userAction'
import { WebToNativeMessage } from "../Common/Utils";

class PKCommonAlert extends React.Component {
  constructor(props) {
    super(props);
    console.log(" PK Common Alert props", this.props.body)
  }

  //To open Myaccount Screen Start
  openMyAccount = (msg) => {
    this.props.toggleModalAction(false)
    WebToNativeMessage(msg)
  }
  
  render() {
    return (
      <div>
        <div className="relative absolute--fill flex justify-center items-center center left-1 right-1 white w7 ">
          <img className="absolute black nt4  left-0 top-0 right-0 h3 w3 center white flex justify-center items-center  pointer z-9999 " src={a23logo} alt="not available" ></img>
          <div className="center br3 ba pa1 b--black-10 flex flex-column br1" style={{ backgroundColor: "#fffdea", color: "#032146", bordercolor: "#EABF6979", paddingTop: "1rem" }}
          >

            <div className="db pt2 f6 mt3 center ph2">
              <img
                className="absolute top-0 right-0 pa2"
                style={{ width: "22px", height: "22px" }}
                src={close}
                alt="no "
                onClick={() => this.props.toggleModalAction(false)}
              ></img>
              <div className="w-100 db  tc">
                <h4 className="mt0 mb2 fw3 pa1 f4 text-bold" style={{ color: "#032146" }}>{this.props.header}</h4>
                <p className="f5 ml3 mr3 fw5 text" style={{ color: "#032146" }}>{this.props.body}</p>
              </div>
              <div className="center tc mt2">
                {this.props.btntext == "Okay" || this.props.btntext == "Close" ? (<button type="submit" className="tc center pointer bw0 ba br2 ph2 dib pv2  ph4 btn-green btn-green-login white" onClick={() => this.props.toggleModalAction(false)}>{this.props.btntext}
                </button>) : (<button type="submit" className="tc center pointer bw0 ba br2 ph2 dib pv2  ph5 btn-green btn-green-login white f6 nowrap" onClick={() => this.openMyAccount({ 
                  type: "openMyAccount"//verifyPAN//openMyAccount
                  , token: window.sessionStorage["token"] })}>{this.props.btntext}
                </button>)}

                <div className="h1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

    )
  }
}
const mapStateToProps = state => ({
  modalState: state.userState
});

export default connect(
  mapStateToProps,
  { toggleModalAction }
)(PKCommonAlert);